import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { TableCell, TableHead, TableRow, TableSortLabel, Checkbox, Tooltip } from '@material-ui/core';

const SimpleTableHead = ({
  classes,
  checked,
  selectAll,
  tableHeaderColor,
  order,
  orderBy,
  headers,
  showCheckbox,
  onRequestSort,
}) => {
  const { t } = useTranslation();

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className={classes[`${tableHeaderColor}TableHeader`]}>
      <TableRow>
        {showCheckbox && (
          <TableCell padding="checkbox">
            <Checkbox checked={checked} color="primary" onChange={selectAll} />
          </TableCell>
        )}
        {headers.map((column) => {
          const numeric = column.format === 'numeric';
          const display = !column.noDisplay;
          return (
            display && (
              <TableCell
                key={column.dataAlias}
                className={clsx(classes.tableCell, classes.tableHeadCell, classes[column.className])}
                sortDirection={orderBy === column.dataAlias ? order : false}
              >
                {column.sortable ? (
                  <Tooltip title={t('Sort')} placement={numeric ? 'bottom-end' : 'bottom-start'} enterDelay={300}>
                    <TableSortLabel
                      active={orderBy === column.dataAlias}
                      direction={order}
                      onClick={createSortHandler(column.dataAlias)}
                    >
                      {t(column.alias)}
                    </TableSortLabel>
                  </Tooltip>
                ) : (
                  t(column.alias)
                )}
              </TableCell>
            )
          );
        }, this)}
      </TableRow>
    </TableHead>
  );
};

SimpleTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string,
  tableHeaderColor: PropTypes.string,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      alias: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      sortable: PropTypes.bool.isRequired,
      format: PropTypes.oneOf(['date', 'string', 'number']),
      dataAlias: PropTypes.string.isRequired,
      className: PropTypes.string,
    })
  ).isRequired,
  selectAll: PropTypes.func,
  showCheckbox: PropTypes.bool,
  checked: PropTypes.bool,
};

SimpleTableHead.defaultProps = {
  showCheckbox: false,
  selectAll: undefined,
  orderBy: undefined,
  tableHeaderColor: undefined,
  checked: false,
};

export default SimpleTableHead;
